// src/redux/modalSlice.ts

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ModalState {
  isOpen: boolean;
  type: 'project' | 'image' | 'analyze' | 'report' | 'subscription' | 'invite-join-confirm' | 'invite-error' | 'invite-send' | null;  // you can add more content types here
  width: 'sm' | 'md' | 'lg' | 'xl' | 'full' | string;
  dismissible: boolean;
  props: any;
}

interface CloseModalPayload extends PayloadAction<{ type: 'project' | 'image' | 'analyze' | 'report' | 'subscription' | 'invite-join-confirm' | 'invite-error' | 'invite-send', width?: 'sm' | 'md' | 'lg' | 'xl' | 'full' | string, dismissible?: boolean, props: any }> {}

interface OpenModalPayload extends CloseModalPayload {}

const initialState: ModalState = {
  isOpen: false,
  type: null,
  width: 'md',
  dismissible: true,
  props: {},
};

export const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openModal: (state, action: OpenModalPayload) => {
      console.log("🚀 ~ file: modalSlice.ts:28 ~ action:", action)
      state.isOpen = true;
      state.type = action.payload.type;
      state.width = action.payload.width || 'md';
      state.dismissible = action.payload.dismissible !== undefined ? action.payload.dismissible : true;
      state.props = action.payload.props;
    },
    closeModal: (state) => {
      state.isOpen = false;
      state.type = null;
      state.dismissible = true;
      state.props = {};
    },
  },
});

export const { openModal, closeModal } = modalSlice.actions;

export default modalSlice.reducer;
